/**
 * Quiet usage tracking — fire-and-forget page/surface view pings so the
 * admin "Usage" panel (System Health) can show which pages are actually
 * used vs dead. Never blocks navigation, never throws, never awaited.
 *
 * Added 2026-10-01 per user ask to instrument the app before cutting pages.
 *  - sendBeacon is preferred so the ping survives the view unmounting.
 *  - A short same-key de-dupe swallows the double-fire from React effects
 *    re-running (e.g. the role/view effect commits twice).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ENDPOINT = `${API}/usage/track`;

let _lastKey = "";
let _lastAt = 0;

export function trackView(page, meta = {}) {
  try {
    const key = String(page || "").trim().toLowerCase();
    if (!key) return;
    const now = Date.now();
    if (key === _lastKey && now - _lastAt < 1500) return; // collapse rapid repeats
    _lastKey = key;
    _lastAt = now;
    const payload = JSON.stringify({
      page: key,
      crew_id: meta.crewId || "",
      store_id: meta.storeId || "",
      role: meta.role || "",
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: "application/json" }));
      return;
    }
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => { /* swallow — telemetry must never break the app */ });
  } catch {
    /* nothing */
  }
}
